// import "react-toastify/dist/ReactToastify.css";

// import { ToastContainer } from "react-toastify";
import { RoutingApp } from "./RoutingApp";
import '@fontsource/urbanist';  // This will load the default weight (400).
import '@fontsource/urbanist/400.css'; // Regular
import '@fontsource/urbanist/500.css'; // Medium
import '@fontsource/urbanist/700.css'; // Bold
import '@fortawesome/fontawesome-free/css/all.min.css';

const App = () => (
  <>
    <RoutingApp />

    {/* <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    /> */}
  </>
);

export default App;
